export const IDENTITY_SDK_RESET_COOKIE = "identitySdkResetRequired";
